module.exports = __webpack_public_path__ + "img/enrollment-scholar.3974f057.svg";